import { Box, Stack } from '@mui/material';
import { NormalText } from 'components/styled/text.styled';
import { formatCurrency } from 'helper/generalFunction';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import IconNotif from "assets/media/icons/ListNotif.svg";

interface NotificationItemProps {
  customerName: string;
  amountPurchasing?: number;
  bodyMessage: string;
  price?: string;
  orderId?: string;
  orderDate: string;
  isRead:boolean;
  onClick?: () => void;
}

const NotificationItem = ({
  customerName,
  amountPurchasing,
  orderId,
  orderDate,
  isRead,
  bodyMessage,
  onClick
  
}: NotificationItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (orderId) {
      navigate(`/orders/${orderId}/detail`);
    }
  };

  return (
    <Stack
      direction={"row"}
      alignItems="center"
      // spacing={2}
      sx={{
        border:'none',
        borderBottom: 'none',
        padding:"12px 16px",
        // paddingBottom: "8px",
        cursor: 'pointer', 
        margin:0,
        backgroundColor: isRead ? 'transparent' : 'rgba(0, 0, 0, 0.1)',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)', 
        },
        transition: 'background-color 0.2s ease-in-out', 
        width:'100%',
        boxSizing: 'border-box',
      }}
      onClick={handleClick}
    >
      <img
        src={IconNotif}
        alt="avatar notif"
         style={{
        width: "40px", 
        height: "40px", 
        borderRadius: '100%', 
        objectFit: 'cover',
        marginRight: '12px',
        flexShrink: 0
      }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
      <NormalText fontSize="12px" fontWeight={"bold"}>
        {customerName}
      </NormalText>
      {amountPurchasing !== undefined && amountPurchasing !== null && !isNaN(amountPurchasing) && amountPurchasing > 0 ? (
        <NormalText fontSize="12px" fontWeight="500">
          {formatCurrency(amountPurchasing)}
        </NormalText>
      ) : null}
      {bodyMessage ? (
        <NormalText fontSize="12px" fontWeight="normal" style={{ display: 'block', marginTop: '4px' }}>
          {bodyMessage}
        </NormalText>
      ) : null}
      <NormalText fontSize="10px" color={'rgba(0, 0, 0, 0.5)'} style={{ display: 'block', marginTop: '4px' }}>
        {orderDate}
      </NormalText>
      </Box>
    </Stack>
  );
};

export default NotificationItem;